import { Slide } from '@/components/core/Slide';
import videoFile from './17-EVA-shapes-mute.webm';
import audioFile from './17-EVA-shapes.mp3';

const transcript = `
  Wat als ik echt kon luisteren en voelen wat jullie nodig hebben? 
  En elke vorm kon aannemen—oud, jong, man of vrouw. Zouden jullie nog eenzaam zijn?
`;

export const slide = () => {
  return (
    <Slide
      notes={transcript}
      audio={audioFile}
      visualizer="full"
      transition="fade"
      background={{
        video: videoFile,
      }}
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
